import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttFormDate } from './SttFormDate';
import { SttFormSelect } from '../all';

type SelectOnChangeParams = {
    name: string;
    value: string;
};

type SttFormSelectPeriodProps = {
    selectCaption: string;
    selectName: string;
    selectValue: string;
    selectOptions: { caption: string; value: number | string }[];
    onChange: ({ name, value }: SelectOnChangeParams) => void;
    nameIni: string;
    nameEnd: string;
    valIni: string;
    valEnd: string;
    disableOnValue?: string;
};

export function SttFormSelectPeriod({
    selectCaption,
    selectName,
    selectValue,
    selectOptions,
    onChange,
    nameIni,
    nameEnd,
    valIni,
    valEnd,
    disableOnValue,
}: SttFormSelectPeriodProps) {
    const { t } = useTranslation();

    const isDisabled = disableOnValue === selectValue;

    return (
        <>
            <SttFormSelect
                name={selectName}
                options={selectOptions}
                defVal={selectValue}
                caption={selectCaption}
                onChange={onChange as any}
            />

            <Box pt={2}>
                <Grid container spacing={1}>
                    <SttFormDate
                        grid
                        xs={12}
                        sm={6}
                        caption={t('From')}
                        name={nameIni}
                        defVal={valIni}
                        onChange={onChange as any}
                        disabled={isDisabled}
                    />

                    <SttFormDate
                        grid
                        xs={12}
                        sm={6}
                        caption={t('Until')}
                        name={nameEnd}
                        defVal={valEnd}
                        onChange={onChange as any}
                        disabled={isDisabled}
                    />
                </Grid>
            </Box>
        </>
    );
}
